import Vue from 'vue';
import config from './api-config';
import qs from 'qs';

declare var AppInsightsUtils: any;


export class Services {
    public json(body: any){
        return new Blob(body);
    }

    public async loginUser(userpassword: string) {
        return await Vue.axios({
            method: 'post',
            url: config.loginUser,
            withCredentials: true,
            data: {
              val: userpassword,
            },
          }).then((response) =>{
            if (response.status !== 200) {
                throw Error('Failed - Incorrect Response');
            }

            return response.data;
          });
    }

    public async loginPgcUser(parameter0: any, parameter1: any){
        const username = parameter0.split(':')[0];
        const password = parameter0.split(':')[1];

        const CMSresponse = await this.loginCMSUser(username, password);

        if (CMSresponse.data[0].Data[0].Status !== '900'){
            throw Error('Response not Authenticated');
        }

        return await Vue.axios({
                method: 'post',
                url: config.loginUser,
                withCredentials: true,
                data: {
                    val: parameter0,
                },
            }).then((response) => {
                if (response.status !== 200) {
                    throw Error('Failed - Incorrect Response');
                }

                AppInsightsUtils.setAuthNUserContext(true, username);

                return response.data;
            });
    }


    public async loginCMSUser(username: string, password: string){
        const configCMS = {
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded',
            },
        };

        const pgcIndex = username.indexOf('@pgc.edu.pk');
        const randMac = "XX:XX:XX:XX:XX:XX".replace(/X/g, function() {
            return "0123456789ABCDEF".charAt(Math.floor(Math.random() * 16));
        });

        localStorage[config.macAddress] = randMac;

        if (pgcIndex !== -1) {
            username = username.substring(0, pgcIndex);
        }

        const deviceId = username + window.navigator.userAgent.replace(/\D+/g, '');
        const deviceName =  this.get_browser_info();

        const requestBody = {
            User_name: username,
            User_Password: btoa(password),
            Device_Id: deviceId,
            Application_Name: 'E-Learning',
            Application_Version: '1.0',
            AppName: 'PGC',
            UserMacAddress: randMac,
            Device_Name: deviceName.name,
        };

        const response = await Vue.axios.post('https://el.pgc.edu/api/middleware/Login',
         qs.stringify(requestBody), configCMS);

        localStorage[config.deviceId] = deviceId;
        localStorage[config.username] = username;
        return response;
    }

    public get_browser_info() {
        const ua: string = navigator.userAgent;
        let tem;
        let M = ua
        .match(/(opera|chrome|safari|firefox|msie|trident(?=\/))\/?\s*(\d+)/i) || [];
        if (/trident/i.test(M[1])){
            tem = /\brv[ :]+(\d+)/g.exec(ua) || [];
            return {name:  'IE ', version: (tem[1] || '')};
            }
        if (M[1] === 'Chrome'){
            tem = ua.match(/\bOPR\/(\d+)/)
            if (tem != null)   {return {name: 'Opera', version: tem[1]}; }
            }
        M = M[2] ? [M[1], M[2]]: [navigator.appName, navigator.appVersion, '-?'];
        if (( tem = ua.match(/version\/(\d+)/i)) != null) {M.splice(1, 1, tem[1]); }
        return {
          name: M[0],
          version: M[1]
        };
     }


}

